/**
 * U SSO
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CredentialParams { 
    /**
     * Credential unique identifier.
     */
    idHash?: string;
    /**
     * Credential transaction signed by the subject. This transaction must contain the subjectCredentialHash to record on the blockchain for this subject. Encoded in Base64 format
     */
    subjectCredentialTransactionSigned?: CredentialParams.SubjectCredentialTransactionSignedEnum;
    /**
     * Credential keys filter, for example: \'iban - ES2100000000000000000000\' and \'swift - BANKESMM000\' for CredentialName = BankAccount 
     */
    credentialKeysFilter?: { [key: string]: string; };
}
export namespace CredentialParams {
    export const SubjectCredentialTransactionSignedEnum = {
        B642505c7: '[B@642505c7'
    } as const;
    export type SubjectCredentialTransactionSignedEnum = typeof SubjectCredentialTransactionSignedEnum[keyof typeof SubjectCredentialTransactionSignedEnum];
}


